import { render } from "./Procurement Management Policy.vue?vue&type=template&id=21e4588d&scoped=true"
const script = {}

import "./Procurement Management Policy.vue?vue&type=style&index=0&id=21e4588d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e4588d"]])

export default __exports__